import * as actionTypes from './actionTypes';

export const toggleAgreementUpdateModal=()=>({
    type:actionTypes.TOGGLE_UPDATE_AGREEMENT_MODAL
})